import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import MainCard from "components/MainCard";
import { connect } from "react-redux";
import { Grid, Button } from "@mui/material";
import { Pagination, Spin } from "antd";
import { dispatch } from "store/index";
import { FetchAllCompaigns, FetchCallActivity } from "store/action/index";
import CampaignCard from "components/cards/statistics/CallManagerCard";
import { CircularProgress } from '@mui/material';


const AllCampaigns = ({ activityCall }) => {
  const [loading, setLoading] = useState(true);
  const [params, setparams] = useState({});

  useEffect(() => {
    setLoading(true);
    dispatch(FetchCallActivity({ params: { ...params, activity_id: 2 }, setLoading }));
  }, [params]);

  const handlePageChange = (page) => {
    setparams({ ...params, page });
  };

  useEffect(() => {
  }, [activityCall])

  return (
    <>
      <Spin spinning={loading}>
        <div className="mb-4">
          <MainCard>
            <div style={{ display: "flex" }}>
              <Grid container alignItems="center" justifyContent="flex-start">
                <Grid item>
                  <span
                    style={{
                      fontSize: "22px",
                      fontWeight: "600",
                    }}
                  >
                    Call Manager
                  </span>
                </Grid>
              </Grid>
            </div>
          </MainCard>
        </div>

        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "20px",
            }}
          >
            {Array.isArray(activityCall?.data?.data) ? (
              activityCall?.data?.data?.map((campaign) => (
                <CampaignCard key={campaign.id} campaign={campaign} />
              ))
            ) : (
              <p>No Data</p>
            )}
          </div>
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Pagination
              current={activityCall?.data?.current_page || 1}
              total={activityCall?.data?.total || 0}
              pageSize={activityCall?.data?.per_page || 10}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        </>
      </Spin>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    activityCall: state?.ActivityCallRedc?.activityCall,
  };
};

export default connect(mapStateToProps)(AllCampaigns);
